import _enum from "./enum";
import stringHelpers from "./stringHelpers";

const quarter = (month) => {
  return Math.floor(month / 3);
}

export const startOfDay = (date) => {
  let theDate = new Date(date);
  const start = theDate.setHours(0, 0, 0, 0)
  return new Date(start)
}

export const endOfDay = (date) => {
  let theDate = new Date(date);
  const end = theDate.setHours(23, 59, 59)
  return new Date(end)
}

const firstDayOfMonth = (date) => {
  let theDate = new Date(date);
  theDate.setDate(1);
  theDate.setHours(0, 0, 0, 0);

  return theDate;
}

const lastDayOfMonth = (date) => {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59);
}

const quarterStartingDate = (date) => {        
  let theDate = new Date(date);
  return new Date(theDate.getFullYear(), 3 * quarter(theDate.getMonth()), 1);
}

const quarterEndingDate = (date) => {
    let theDate = new Date(date);
    let startingDate = quarterStartingDate(theDate);
    let endingDate = new Date(startingDate.setMonth(startingDate.getMonth() + 3));
    endingDate = new Date(endingDate.setSeconds(endingDate.getSeconds() - 1));
    
    return endingDate;
}

export const currentMonthDateRange = () => {
  const today = new Date();
  let year = today.getFullYear();
  const first = firstDayOfMonth(today); 
  return {
    firstDate: first,
    lastDate: lastDayOfMonth(today),
    displayString: `${ first.toLocaleString("en", {month: "short"}) } ${ year }`
  }
}

export const previousMonthDateRange = () => {
  const date = new Date();
  date.setMonth(date.getMonth() - 1)
  let year = date.getFullYear();
  const first = firstDayOfMonth(date); 
  return {
    firstDate: firstDayOfMonth(date),
    lastDate: lastDayOfMonth(date),
    displayString: `${ first.toLocaleString("en", {month: "short"}) } ${ year }`
  }
}

export const currentQuarterDateRange = () => {
  const today = new Date();
  
  const firstDayOfQuarter = quarterStartingDate(today);
  const lastDayOfQuarter = quarterEndingDate(today);

  return {
    firstDate: firstDayOfQuarter,
    lastDate: lastDayOfQuarter,
    displayString: `${firstDayOfQuarter.getDate()} ${firstDayOfQuarter.toLocaleString("en", {month: "short"})} - ${lastDayOfQuarter.getDate()} ${lastDayOfQuarter.toLocaleString("en", {month: "short"})} ${firstDayOfQuarter.getFullYear()}`
  }
}

export const previousQuarterDateRange = () => {
  const date = new Date();
  date.setMonth(date.getMonth() - 3)
  const firstDayOfQuarter = quarterStartingDate(date);
  const lastDayOfQuarter = quarterEndingDate(date);

  return {
    firstDate: firstDayOfQuarter,
    lastDate: lastDayOfQuarter,
    displayString: `${firstDayOfQuarter.getDate()} ${firstDayOfQuarter.toLocaleString("en", {month: "short"})} - ${lastDayOfQuarter.getDate()} ${lastDayOfQuarter.toLocaleString("en", {month: "short"})} ${firstDayOfQuarter.getFullYear()}`
  }
}

const firstDayOfYear = (year) => new Date(year, 0, 1, 0);

const lastDayOfYear = (year) => {
  let date = firstDayOfYear(year)
  date.setFullYear(year + 1)
  date.setSeconds(date.getSeconds() - 1)
  return date;
};

const fullYearDateRange = (year) => {
  const first = firstDayOfYear(year);
  const last = lastDayOfYear(year);
  return {
    firstDate: first,
    lastDate: last,
    displayString: `${first.getDate()} ${first.toLocaleString("en", {month: "short"})} - ${last.getDate()} ${last.toLocaleString("en", {month: "short"})} ${year}`
  }
}

const yearToDateRange = () => {
  const today = new Date();
  const first = firstDayOfYear(today.getFullYear());

  return {
    firstDate: first,
    lastDate: today,
    displayString: `${first.getDate()} ${first.toLocaleString("en", {month: "short"})} - ${today.getDate()} ${today.toLocaleString("en", {month: "short"})} ${today.getFullYear()}`
  }
}

const monthToDateRange = () => {
  const today = new Date();
  const first = firstDayOfMonth(today); 
  
  return {
    firstDate: first,
    lastDate: today,
    displayString: `${first.getDate()} ${first.toLocaleString("en", {month: "short"})} - ${today.getDate()} ${today.toLocaleString("en", {month: "short"})} ${today.getFullYear()}`
  }
}

const quarterToDateRange = () => {
  const today = new Date();
  const year = today.getFullYear();
  
  const firstDayOfQuarter = quarterStartingDate(today);

  return {
    firstDate: firstDayOfQuarter,
    lastDate: today,
    displayString: `${firstDayOfQuarter.getDate()} ${firstDayOfQuarter.toLocaleString("en", {month: "short"})} - ${today.getDate()} ${today.toLocaleString("en", {month: "short"})} ${year}`
  }
}

const currentDayRange = () => {
  const today = new Date();
  const start = startOfDay(today)
  const end = endOfDay(today)
  return {
    firstDate: start,
    lastDate: end,
    displayString: `${today.getDate()} ${today.toLocaleString("en", {month: "short"})} ${today.getFullYear()}`
  }
}

export const dateRange = (dateRangeType) => {
  switch (dateRangeType) {
    case "currentDay":
      return currentDayRange();
    case "lastMonth":
      return previousMonthDateRange();
    case "currentMonth":
      return currentMonthDateRange();
    case "currentQuarter":
      return currentQuarterDateRange();
    case "lastQuarter":
      return previousQuarterDateRange();
    case "currentYear":
      return fullYearDateRange(new Date().getFullYear());
    case "lastYear":
      return fullYearDateRange(new Date().getFullYear() - 1);
    case "yearToDate":
      return yearToDateRange();
    case "monthToDate":
      return monthToDateRange();
    case "quarterToDate":
      return quarterToDateRange();
  }
}

export const toInputFieldDateString = (dateValue) => {
  if (!dateValue) return "yyyy-MM-dd";
  const dateObject = new Date(dateValue)
  const date = dateObject.getDate();
  const month = dateObject.getMonth() + 1;
  return `${dateObject.getFullYear()}-${stringHelpers.ensurePrecedingZero(month)}-${stringHelpers.ensurePrecedingZero(date)}`
}

export const fromInputFieldDateString = (dateString) => {
  if (!dateString) return null;
  const [year, month, day] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day);
}

export const areDatesEqual = (dateOne, dateTwo) => {
  const first = new Date(dateOne)
  const second = new Date(dateTwo)
  return (
    first.getDate() === second.getDate() && 
    first.getMonth() === second.getMonth() &&
    first.getFullYear() === second.getFullYear()
  )
}

export const toDateString = (timestamp) => {
  if (!timestamp) return ""
  const dateObject = new Date(timestamp)
  return `${stringHelpers.ensurePrecedingZero(dateObject.getDate())}/${stringHelpers.ensurePrecedingZero(dateObject.getMonth() + 1)}/${dateObject.getFullYear()}`
}

export const toTimeString = (timestamp, includeSeconds=false) => {
    if (!timestamp) return ""
    const dateObject = new Date(timestamp)
    const hours = dateObject.getHours()
    const minutes = dateObject.getMinutes()
    return `${stringHelpers.ensurePrecedingZero(hours)}:${stringHelpers.ensurePrecedingZero(minutes)}${includeSeconds ? `:${stringHelpers.ensurePrecedingZero(dateObject.getSeconds())}` : ""}`
}

export const toDateTimeString = (timestamp, includeSeconds=false) => {
  if (!timestamp) return ""
  return `${toDateString(timestamp)} ${toTimeString(timestamp, includeSeconds)}`
}

export const toLongDateTimeString = (timestamp) => {
  if (!timestamp) return ""
  const dateObject = new Date(timestamp)
  return `${dateObject.getDate()} ${dateObject.toLocaleString("en", {month: "long"})} ${dateObject.getFullYear()} ${toTimeString(timestamp)}`
}

const ordinalPluralRules = new Intl.PluralRules('en-GB', { type: 'ordinal' });
const ordinalSuffixes = {
    one: 'st',
    two: 'nd',
    few: 'rd',
    other: 'th'
};

export const getOrdinalDayOfMonth = (day) => `${day}${ordinalSuffixes[ordinalPluralRules.select(day)]}`;

export const addHours = (timestamp, hoursToAdd) => {
  const dateObject = new Date(timestamp)
  dateObject.setHours(dateObject.getHours() + hoursToAdd)
  return dateObject
}

export const subtractDays = (timestamp, numberOfDaysToSubtract) => {
  const dateObject = new Date(timestamp)
  dateObject.setDate(dateObject.getDate() - numberOfDaysToSubtract)
  return dateObject
}

export const toTwelveHourTimeString = (timestamp) => {
  if (!timestamp) return ""
  const dateObject = new Date(timestamp)
  const hours = dateObject.getHours() % 12 || 12
  return `${stringHelpers.ensurePrecedingZero(hours)}:${stringHelpers.ensurePrecedingZero(dateObject.getMinutes())}`
}

export const toInputFieldDateTimeString = (timestamp) => {
  if (!timestamp) return "yyyy-MM-dd"
  return `${toInputFieldDateString(timestamp)}T${toTimeString(timestamp)}`
}

export const isDateTimeElapsed = (timestamp) => {
  const dateObject = new Date(timestamp)
  return(dateObject.valueOf() < Date.now())
}

export const daysToHours = (days) => {
  return days * 24
}

export const hoursToMinutes = (hours) => {
  return hours * 60
}

export const daysToMinutes = (days) => {
  return hoursToMinutes(daysToHours(days))
}

export const unitToMinutes = (timeValue, unit) => {
  const value = Number(timeValue)
  if (unit === 0) {
    return value
  }
  switch(unit) {
    case 1:
      return hoursToMinutes(value)
    case 2: 
      return daysToMinutes(value)
    default:
      return value
  }
}

export const minutesToUnit = (numberOfMinutes) => {
  if (numberOfMinutes > 0) {
    if (numberOfMinutes % 1440 === 0) {
      return { value: numberOfMinutes / 1440, unit: 2 }
    }
    else if (numberOfMinutes % 60 === 0) {
      return { value: numberOfMinutes / 60, unit: 1 }
    }
  }
  return { value: numberOfMinutes, unit: 0 }
}

export const millisecondsToHoursAndMinutes = (numberOfMilliseconds) => {
  const hours = Math.floor(numberOfMilliseconds / 3600000)
  const minutes = Math.floor((numberOfMilliseconds % 3600000) / 60000)
  return {
    hours,
    minutes
  }
}

export const sortArrayOfObjectsByTimestampProperty = (array, key = "timestamp") => {
  return [...array].sort((a, b) => {
    const aVal = key in a ? a[key] : null;
    const bVal = key in b ? b[key] : null;

    const aEmpty = stringHelpers.isNullOrEmpty(aVal);
    const bEmpty = stringHelpers.isNullOrEmpty(bVal);

    if (aEmpty && bEmpty) return 0;
    if (aEmpty) return 1;
    if (bEmpty) return -1;

    return new Date(bVal) - new Date(aVal);
  });
}

export const isToDateAfterFromDate = (from, to) => {
  if (stringHelpers.isNullOrEmpty(from) || stringHelpers.isNullOrEmpty(to)) return true;

  const fromDate = new Date(from);
  const toDate = new Date(to);

  if (isNaN(fromDate.getTime()) || isNaN(toDate.getTime())) return false;
  return toDate > fromDate;
}

export const durationBetweenInMilliseconds = (timestampOne, timestampTwo) => {
  if (!timestampOne || !timestampTwo) return null;
  const start = new Date(timestampOne);
  const end = new Date(timestampTwo);
  if (isNaN(start.getTime()) || isNaN(end.getTime())) return null;
  return Math.abs(end - start);
}

export const durationBetweenString = (timestampOne, timestampTwo) => {
  let diffMs = durationBetweenInMilliseconds(timestampOne, timestampTwo);
  if (diffMs === null) return "";

  const YEAR_MS   = 365 * 24 * 60 * 60 * 1000;
  const MONTH_MS  =  30 * 24 * 60 * 60 * 1000;
  const DAY_MS    =       24 * 60 * 60 * 1000;
  const HOUR_MS   =            60 * 60 * 1000;
  const MINUTE_MS =                 60 * 1000;
  const SECOND_MS =                      1000;

  const parts = [];

  if (diffMs >= YEAR_MS) {
    const years = Math.floor(diffMs / YEAR_MS);
    parts.push(`${years} ${stringHelpers.pluralSuffixModifier(years, "years")}`);
    diffMs %= YEAR_MS;
  }

  if (diffMs >= MONTH_MS) {
    const months = Math.floor(diffMs / MONTH_MS);
    parts.push(`${months} ${stringHelpers.pluralSuffixModifier(months, "months")}`);
    diffMs %= MONTH_MS;
  }

  if (diffMs >= DAY_MS) {
    const days = Math.floor(diffMs / DAY_MS);
    parts.push(`${days} ${stringHelpers.pluralSuffixModifier(days, "days")}`);
    diffMs %= DAY_MS;
  }

  if (diffMs >= HOUR_MS) {
    const hours = Math.floor(diffMs / HOUR_MS);
    parts.push(`${hours} ${stringHelpers.pluralSuffixModifier(hours, "hours")}`);
    diffMs %= HOUR_MS;
  }

  if (diffMs >= MINUTE_MS) {
    const minutes = Math.floor(diffMs / MINUTE_MS);
    parts.push(`${minutes} ${stringHelpers.pluralSuffixModifier(minutes, "minutes")}`);
    diffMs %= MINUTE_MS;
  }

  if (diffMs >= SECOND_MS) {
    const seconds = Math.floor(diffMs / SECOND_MS);
    parts.push(`${seconds} ${stringHelpers.pluralSuffixModifier(seconds, "seconds")}`);
  }

  return parts.join(", ");
}

export const timeAgo = (timestamp) => {
  if (!timestamp) return "";
  const date = new Date(timestamp);
  if (isNaN(date.getTime()) || date.valueOf() > Date.now()) return "";
  const diffMs = Date.now() - date.valueOf();

  const diffSeconds = Math.floor(diffMs / 1000);
  if (diffSeconds < 60) {
    return "just now";
  }

  const diffMinutes = Math.floor(diffSeconds / 60);
  if (diffMinutes < 60) {
    return `${diffMinutes} ${stringHelpers.pluralSuffixModifier(diffMinutes, "minutes")} ago`;
  }

  const diffHours = Math.floor(diffMinutes / 60);
  if (diffHours < 24) {
    return `${diffHours} ${stringHelpers.pluralSuffixModifier(diffHours, "hours")} ago`;
  }

  const diffDays = Math.floor(diffHours / 24);
  if (diffDays < 7) {
    return `${diffDays} ${stringHelpers.pluralSuffixModifier(diffDays, "days")} ago`;
  }

  const diffWeeks = Math.floor(diffDays / 7);
  if (diffWeeks < 5) {
    return `${diffWeeks} ${stringHelpers.pluralSuffixModifier(diffWeeks, "weeks")} ago`;
  }

  const diffMonths = Math.floor(diffDays / 30);
  if (diffMonths < 12) {
    return `${diffMonths} ${stringHelpers.pluralSuffixModifier(diffMonths, "months")} ago`;
  }

  const diffYears = Math.floor(diffDays / 365);
  return `${diffYears} ${stringHelpers.pluralSuffixModifier(diffYears, "years")} ago`;
}

export const daysAgo = (timestamp) => {
  if (!timestamp) return null;
  const date = new Date(timestamp);
  if (isNaN(date.getTime())) return null;
  const diffMs = Date.now() - date.valueOf();
  return Math.floor(diffMs / (1000 * 60 * 60 * 24));
}